import { db } from "@/firebaseConfig";

const scheduleDessertCollection = db.collection("schedule_dessert");

const saveScheduleDessert = async (id, data) => {
  scheduleDessertCollection
    .doc(id)
    .set(data)
    .then(() => {
      console.log("ScheduleDessert successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updateScheduleDessert = async (id, data) => {
  scheduleDessertCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("ScheduleDessert successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deleteScheduleDessert = async id => {
  scheduleDessertCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("ScheduleDessert successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getScheduleDessertById = async id => {
  return scheduleDessertCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

export {
  scheduleDessertCollection,
  saveScheduleDessert,
  updateScheduleDessert,
  deleteScheduleDessert,
  getScheduleDessertById
};
